/**
 *
 * @module environmentConfiguration
 *
 */

/**
 *
 * @class EnvironmentConfiguration
 * @desc Provides configuration information that describes the current environment
 * and is used by the ConfigurationClient to retrieve the SdkSessionConfiguration
 * necessary to create an SdkSession instance.
 *
 */
export default class EnvironmentConfiguration {

    /**
     *
     * @param {String} applicationRuntime
     * @param {String} applicationRuntimeProfile
     * @param {String} applicationVersion
     * @param {String} deviceFamily
     * @param {String} deviceProfile
     * @param {String} deviceRuntimeProfile
     * @param {String} sdkVersion
     * @param {String} configVersion
     *
     */
    constructor({ applicationRuntime, applicationRuntimeProfile, applicationVersion,
        deviceFamily, deviceProfile, deviceRuntimeProfile,
        sdkVersion, configVersion } = {}) {

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets or sets the application runtime.
         *
         */
        this.applicationRuntime = applicationRuntime || 'trilithium';

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets or sets the application runtime profile (e.g. "debug", "release").
         *
         */
        this.applicationRuntimeProfile = applicationRuntimeProfile || 'release';

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets or sets the application version.
         *
         */
        this.applicationVersion = applicationVersion || '';

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets or sets the device family (e.g. "browser").
         *
         */
        this.deviceFamily = deviceFamily || 'browser';

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets or sets the device profile (e.g. "desktop", "sony").
         *
         */
        this.deviceProfile = deviceProfile || 'sony';

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets or sets the device runtime profile.
         *
         */
        this.deviceRuntimeProfile = deviceRuntimeProfile || '';

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets or sets the SDK version (e.g. "3.9").
         *
         */
        this.sdkVersion = sdkVersion || '3.9';

        /**
         *
         * @access public
         * @type {String}
         * @desc Gets or sets the configuration version (e.g. "2.0").
         *
         */
        this.configVersion = configVersion || '2.0';

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.platform = '';

        /**
         *
         * @access private
         * @type {Object}
         *
         */
        this.device = global.engine.stats.device;

        /**
         *
         * @desc Initialize properties based on runtime device values.
         *
         */
        this.init();

    }

    /* #region private: */

    /**
     *
     * @access private
     * @desc Initialize the environment config properties based on runtime device values.
     *
     */
    init() {

        const { device, deviceRuntimeProfile } = this;

        const major = device.version[0] || 0;
        const minor = device.version[1] || 0;
        const revision = device.version[2] || 0;

        if (!deviceRuntimeProfile || deviceRuntimeProfile.trim() === '') {
            this.deviceRuntimeProfile = `${major}.${minor}.${revision}`;
        }

        this.platform = device.platform;

    }

}



// WEBPACK FOOTER //
// ./src/services/platforms/sony/trilithium/environmentConfiguration.js